import { Navigate } from 'react-router-dom';
import { IS_USER_ACCESS_PAGE } from '../config/constants';

const ProtectedRoute = ({ controller, action, children }) => {
    const { is_access_page } = IS_USER_ACCESS_PAGE(controller, action);
    if (!is_access_page) {
        return <Navigate to="/access-denied" replace />;
    }
     
    return children;
};

export default ProtectedRoute;
